import styled from 'styled-components';
import { fontSize, fontWeight, space, textAlign, color } from 'styled-system';

import { colors } from '@styles/theme';

const AnchorText = styled.a`
  ${space}
  ${textAlign}
  ${fontSize}
  ${fontWeight}
  ${color}
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${props => (props.disabled ? 'none' : 'all')};
  text-decoration: underline;

  color: ${props => (props.disabled ? colors.lighterGold : colors.darkGold)};

  &:hover {
    color: ${colors.lightGold};
  }

  &:active {
    color: ${colors.darkGold};
  }
`;

export default AnchorText;
